var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fb",
    transform: "translate(-1522 -12264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6845",
    "data-name": "Rectangle 6845",
    width: 32,
    height: 32,
    rx: 5,
    transform: "translate(1522 12264)",
    fill: "#02a2ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook-f",
    "data-name": "Icon awesome-facebook-f",
    d: "M10.09,9.531l.471-3.066H7.618V4.475A1.533,1.533,0,0,1,9.347,2.818h1.338V.207A16.312,16.312,0,0,0,8.31,0C5.887,0,4.3,1.469,4.3,4.127V6.465H1.609V9.531H4.3v7.413H7.618V9.531Z",
    transform: "translate(1531.391 12272)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.50051285aeeca35e64aefc91e1f26d70.svg";
export { ForwardRef as ReactComponent };